import { render } from "./SiteHeader.vue?vue&type=template&id=06a364c0&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"

import "./SiteHeader.vue?vue&type=style&index=0&id=06a364c0&scoped=true&lang=scss"

import exportComponent from "/Users/gj/Documents/projects/zwrtwt/zwit-planner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a364c0"]])

export default __exports__